// extracted by mini-css-extract-plugin
export default {"button":"TORFTf","disable-theme":"O_uxeU","disableTheme":"O_uxeU","rounded":"GkX5MV"};